import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "step-address" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "m-0" }, " Wo wohnen Sie? ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "fs-regular m-0" }, " Die Angabe ihres Wohnorts hilft Ihnen dabei, das Solarstrom-Potenzial ihres Daches zu bestimmen, das es sich von Stadt zu Stadt unterscheidet. ", -1)
const _hoisted_4 = { class: "row g-4" }
const _hoisted_5 = { class: "col-12" }

import {
  computed,
} from 'vue';
import {
  useStore,
} from 'vuex';
import AddressGroup from '@/components/SolarLeadForm/AddressGroup.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'StepAddress',
  setup(__props) {

const store = useStore();

const form = computed({
  get() {
    return store.getters['leadForm/data'];
  },
  set(data) {
    store.commit('leadForm/setData', data);
  },
});

const formErrors = computed({
  get() {
    return store.getters['leadForm/errors'];
  },
  set(errors) {
    store.commit('leadForm/setErrors', errors);
  },
});

return (_ctx: any,_cache: any) => {
  const _component_BaseSpacer = _resolveComponent("BaseSpacer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_BaseSpacer, { size: "s" }),
    _hoisted_3,
    _createVNode(_component_BaseSpacer, { size: "l" }),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(AddressGroup, {
          postcode: _unref(form).postcode,
          "onUpdate:postcode": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).postcode) = $event)),
          city: _unref(form).city,
          "onUpdate:city": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).city) = $event)),
          street: _unref(form).street,
          "onUpdate:street": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).street) = $event)),
          "house-number": _unref(form).houseNumber,
          "onUpdate:house-number": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).houseNumber) = $event)),
          errors: {
            postcode: _unref(formErrors).postcode,
            city: _unref(formErrors).city,
            street: _unref(formErrors).street,
            houseNumber: _unref(formErrors).houseNumber,
          }
        }, null, 8, ["postcode", "city", "street", "house-number", "errors"])
      ])
    ])
  ]))
}
}

})